var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"v-page-subtitle"},[_c('span',{ref:"content"},[_vm._t("default")],2),_c('span',{staticClass:"v-page-subtitle__count"},[_vm._t("title-postfix")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }